import { configureStore } from '@reduxjs/toolkit';
import counterReducer from '../features/counterSlice';
import imageReducer from '../features/imageSlice';
import authReducer from '../features/authSlice';

const store = configureStore({
  reducer: {
    counter: counterReducer,
    image: imageReducer,
    auth: authReducer,
  },
});

export default store;
